
export enum CloudType { CUMULUS = 'cumulus', STRATUS = 'stratus', STORM = 'storm' }
export enum CloudRenderMode { VOLUMETRIC = 'volumetric', PARTICLES = 'particles', HYBRID = 'hybrid' }

export type CloudConfig = {
  density: number;
  speed: number;
  height: number;
  type: CloudType;
  mode: CloudRenderMode;
  hybridOpacity?: number;
  textureUrl?: string; // optional single sprite texture for particles
  textureUrls?: string[]; // optional multiple sprite textures for variation
  spriteSize?: number; // world units size for particle sprite
  spriteSizeRange?: [number, number]; // optional random size range per sprite
  spritePixelsPerUnit?: number; // how many image pixels correspond to 1 world unit
  spreadX?: number; // horizontal extent in X (world units)
  spreadZ?: number; // horizontal extent in Z (world units)
};

export type BirdConfig = {
  count: number;
  speed: number;
  height: number;
  detailedThreshold: number;
  bounds: { xz: number; yMin: number; yMax: number };
  sizeScale?: number; // uniform scale factor for bird meshes
};

export type LightningConfig = {
  randomMinMs: number;
  randomMaxMs: number;
  boltSegments: number;
  branchCount: number;
  zigzagStrength: number;
  fadePerSec: number;
  flashIntensity: number;
  flashHoldMs: number;
};

export type SunConfig = {
  intensity: number;
  color: number;
  raysCount: number;
  cloudHeightRef: number;
  animate: boolean;
};

export type EnvironmentConfig = {
  clouds?: Partial<CloudConfig>;
  birds?: Partial<BirdConfig>;
  lightning?: Partial<LightningConfig>;
  sun?: Partial<SunConfig>;
};

export type WeatherProfile = {
  clouds?: Partial<CloudConfig>;
  birds?: Partial<BirdConfig>;
  lightning?: Partial<LightningConfig>;
  sun?: Partial<SunConfig>;
};

export type WeatherState = 'clear' | 'cloudy' | 'storm';
